import { Controller } from "@hotwired/stimulus"
import offlineProgressSync from "../src/react/helpers/OfflineProgressSync"
import { PUSH_SUBSCRIPTION_OWNER_KEY, getActivePushSubscription } from "../pwa/pushSubscription"

export default class extends Controller {
  connect() {
    this.clearOfflineUserData()
  }

  async clearOfflineUserData() {
    const pushSubscriptionOwner = localStorage.getItem(PUSH_SUBSCRIPTION_OWNER_KEY)
    localStorage.clear()
    if (pushSubscriptionOwner) localStorage.setItem(PUSH_SUBSCRIPTION_OWNER_KEY, pushSubscriptionOwner)

    if (typeof caches !== "undefined") {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map(name => caches.delete(name)))
    }

    const databases = await indexedDB.databases()
    const otherDatabases = databases.filter(db => db.name !== offlineProgressSync.dbName)
    await Promise.all(otherDatabases.map(db => new Promise((resolve, reject) => {
      const req = indexedDB.deleteDatabase(db.name)
      req.onsuccess = resolve
      req.onerror = reject
      req.onblocked = resolve
    })))
    await offlineProgressSync.discardUnownedData()

    if (!pushSubscriptionOwner) await this.dropUnownedPushSubscription()
  }

  async dropUnownedPushSubscription() {
    const subscription = await getActivePushSubscription()
    await subscription?.unsubscribe()
  }
}
